<mat-paginator #paginator class="" [pageSize]="pageSize" showFirstLastButtons
               [length]="pageTotal" [pageSizeOptions]="pageOptions" (page)="pChanged($event)">
</mat-paginator>
